import { PageHeader } from "@/components/PageHeader";
import { Section, Eyebrow, CTA } from "@/components/kit";
import { Reveal } from "@/components/motion";
import { PassportStamp } from "@/components/PassportStamp";
import { DuoBanner } from "@/components/DuoBanner";
import { Season2Route } from "@/components/Season2Route";
import { WorldMap } from "@/components/WorldMap";
import { CollectibleStamps } from "@/components/PassportStamps";
import { FormatDialogueSection } from "@/components/FormatDialogueSection";
import { LeadSection } from "@/components/LeadSection";
import { EPISODES, IMG } from "@/data/content";

export default function Ruta() {
  return (
    <>
      <PageHeader
        eyebrow="La Ruta · Temporada 1 · Doce sellos"
        eyebrowColor="#81D4FA"
        title={["Un mapa hecho", " de historias."]}
        subtitle="Cada destino tiene un pulso distinto. Esta ruta no se mide en kilómetros, sino en las cosas que aprenden cuando se detienen a escuchar. Cada destino, una historia distinta y un sello nuevo en el pasaporte de Anto & Bella."
      />

      <Section className="!pt-6">
        <Reveal>
          <WorldMap />
        </Reveal>
        <div className="mt-16">
          <Reveal>
            <CollectibleStamps />
          </Reveal>
        </div>
      </Section>

      <Section className="!pt-4">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {EPISODES.map((e, i) => (
            <Reveal
              key={e.n}
              delay={(i % 3) * 0.08}
              className="group relative overflow-hidden rounded-[2rem] bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={e.img}
                  alt={e.city}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
                <div className="absolute -bottom-4 right-4">
                  <PassportStamp
                    code={e.code}
                    label="TEMP.1"
                    color={e.color}
                    rotate={(i % 2 ? 1 : -1) * 10}
                    size={82}
                  />
                </div>
                <span className="absolute left-4 top-4 rounded-full bg-cream/90 px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest text-ink">
                  Ep {e.n}
                </span>
              </div>
              <div className="p-6">
                <p className="font-mono text-[11px] uppercase tracking-widest text-ink/40">
                  {e.country}
                </p>
                <h3 className="mt-1 font-display text-2xl font-extrabold tracking-tight text-ink">
                  {e.city}
                </h3>
                <p
                  className="mt-1 font-mono text-xs uppercase tracking-widest"
                  style={{ color: e.color }}
                >
                  {e.title}
                </p>
                <p className="mt-3 text-sm text-ink/70 leading-relaxed">{e.blurb}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <FormatDialogueSection accent="#81D4FA" alt eyebrow="Así se vive cada episodio" />

      <DuoBanner
        image={IMG.duoMap}
        imgSide="left"
        tint="#81D4FA"
        eyebrowColor="#81D4FA"
        title="Ellas trazan la ruta. Tú decides que llevaran en esa unica maleta."
        text="Bella arma el itinerario perfecto. Anto es caos brillante pero pone los alfileres en el mapa. Juntas recorren el planeta con curiosidad, honestidad y mucho estilo propio. Doce paradas planeadas entre risas."
        cta={{ to: "/episodios", label: "Ver los episodios" }}
      />

      <Section alt className="text-center">
        <Reveal>
          <Eyebrow color="#FF8A80" className="justify-center">
            ¿Te sumas?
          </Eyebrow>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-4xl sm:text-5xl font-extrabold leading-none tracking-tighter text-ink">
           La comunidad que sigue a Anto & Bella antes, durante y después de cada episodio. 
          </h2>
          <CTA to="/episodios" variant="coral" className="mt-8">
            Ver los episodios
          </CTA>
        </Reveal>
      </Section>
      <LeadSection path="/la-ruta" alt />
    </>
  );
}
